// import Welcome from '@/pages/backend/user/welcome/Welcome.vue'
// import SiteInfo from '@/pages/backend/user/siteinfo/SiteInfo.vue'
// import SiteSeo from '@/pages/backend/user/siteseo/SiteSeo.vue'
// import PageCode from '@/pages/backend/user/codemanagement/PageCode.vue'
// import SiteCode from '@/pages/backend/user/codemanagement/SiteCode.vue'
// import Pages from '@/pages/backend/user/pages/Pages.vue'
// import SystemList from '@/pages/backend/user/system/SystemList.vue'
// import SystemCategory from '@/pages/backend/user/system/SystemCategory.vue'
// import SystemArticleList from '@/pages/backend/user/system/SystemArticleList.vue'
// import SystemArticleItem from '@/pages/backend/user/system/SystemArticleItem.vue'
// import SystemArticleRefuse from '@/pages/backend/user/system/SystemArticleRefuse.vue'

// import SystemProductList from '@/pages/backend/user/system/SystemProductList.vue'
// import SystemProductItem from '@/pages/backend/user/system/SystemProductItem.vue'
// import SystemProductRefuse from '@/pages/backend/user/system/SystemProductRefuse.vue'

// import SystemDownloadList from '@/pages/backend/user/system/SystemDownloadList.vue'
// import SystemDownloadItem from '@/pages/backend/user/system/SystemDownloadItem.vue'
// import SystemDownloadAttribute from '@/pages/backend/user/system/SystemDownloadAttribute.vue'
// import SystemDownloadRefuse from '@/pages/backend/user/system/SystemDownloadRefuse.vue'

// import SystemFaqList from '@/pages/backend/user/system/SystemFaqList.vue'
// import SystemFaqItem from '@/pages/backend/user/system/SystemFaqItem.vue'
// import SystemFaqRefuse from '@/pages/backend/user/system/SystemFaqRefuse.vue'

// import SystemInformationList from '@/pages/backend/user/system/SystemInformationList.vue'
// import SystemInformationItem from '@/pages/backend/user/system/SystemInformationItem.vue'
// import SystemInformationAttribute from '@/pages/backend/user/system/SystemInformationAttribute.vue'
// import SystemInformationRefuse from '@/pages/backend/user/system/SystemInformationRefuse.vue'

// import FormList from '@/pages/backend/user/form/FormList.vue'
// import FormInfoList from '@/pages/backend/user/form/FormInfoList.vue'

// import Repertory from '@/pages/backend/user/repertory/Repertory.vue'
// import RepertoryLabel from '@/pages/backend/user/repertory/label/RepertoryLabel.vue'
// import RepertoryWatermark from '@/pages/backend/user/repertory/watermark/RepertoryWatermark.vue'
// import RepertoryRefuse from '@/pages/backend/user/repertory/refuse/RepertoryRefuse.vue'
// // 域名设置
// import DomainView from '@/pages/backend/user/host/domain/DomainView.vue'
// import SiteView from '@/pages/backend/user/host/setup/SiteView.vue'
// import OperateLog from '@/pages/backend/user/operate/Log.vue'
// import Hostip from '@/pages/backend/user/host/hostip/Hostip.vue'
// import Messagenotify from '@/pages/backend/user/host/messagenotify/Messagenotify.vue'
// import Adwords from '@/pages/backend/user/host/adwords/Adwords.vue'

// import Promotion from '@/pages/backend/user/promotion/Promotion.vue'

// import Virtualroot from '@/pages/backend/user/virtualroot/Virtualroot.vue'

// import Backuprestore from '@/pages/backend/user/backuprestore/Backuprestore.vue'

const Welcome = () => import('@/pages/backend/user/welcome/Welcome.vue')
const SiteInfo = () => import('@/pages/backend/user/siteinfo/SiteInfo.vue')
const SiteSeo = () => import('@/pages/backend/user/siteseo/SiteSeo.vue')
const PageCode = () => import('@/pages/backend/user/codemanagement/PageCode.vue')
const SiteCode = () => import('@/pages/backend/user/codemanagement/SiteCode.vue')
const Pages = () => import('@/pages/backend/user/pages/Pages.vue')
const SystemList = () => import('@/pages/backend/user/system/SystemList.vue')
const SystemCategory = () => import('@/pages/backend/user/system/SystemCategory.vue')
const SystemArticleList = () => import('@/pages/backend/user/system/SystemArticleList.vue')
const SystemArticleItem = () => import('@/pages/backend/user/system/SystemArticleItem.vue')
const SystemArticleRefuse = () => import('@/pages/backend/user/system/SystemArticleRefuse.vue')

const SystemProductList = () => import('@/pages/backend/user/system/SystemProductList.vue')
const SystemProductItem = () => import('@/pages/backend/user/system/SystemProductItem.vue')
const SystemProductRefuse = () => import('@/pages/backend/user/system/SystemProductRefuse.vue')

const SystemDownloadList = () => import('@/pages/backend/user/system/SystemDownloadList.vue')
const SystemDownloadItem = () => import('@/pages/backend/user/system/SystemDownloadItem.vue')
const SystemDownloadAttribute = () => import('@/pages/backend/user/system/SystemDownloadAttribute.vue')
const SystemDownloadRefuse = () => import('@/pages/backend/user/system/SystemDownloadRefuse.vue')

const SystemFaqList = () => import('@/pages/backend/user/system/SystemFaqList.vue')
const SystemFaqItem = () => import('@/pages/backend/user/system/SystemFaqItem.vue')
const SystemFaqRefuse = () => import('@/pages/backend/user/system/SystemFaqRefuse.vue')

const SystemInformationList = () => import('@/pages/backend/user/system/SystemInformationList.vue')
const SystemInformationItem = () => import('@/pages/backend/user/system/SystemInformationItem.vue')
const SystemInformationAttribute = () => import('@/pages/backend/user/system/SystemInformationAttribute.vue')
const SystemInformationRefuse = () => import('@/pages/backend/user/system/SystemInformationRefuse.vue')

const SystemPdtableList = () => import('@/pages/backend/user/system/SystemPdtableList.vue')
const SystemPdtableItem = () => import('@/pages/backend/user/system/SystemPdtableItem.vue')
const SystemPdtableAttribute = () => import('@/pages/backend/user/system/SystemPdtableAttribute.vue')
const SystemPdtableRefuse = () => import('@/pages/backend/user/system/SystemPdtableRefuse.vue')

const FormList = () => import('@/pages/backend/user/form/FormList.vue')
const FormInfoList = () => import('@/pages/backend/user/form/FormInfoList.vue')
const SysFormList = () => import('@/pages/backend/user/form/SysFormList.vue')
const SysFormInfoList = () => import('@/pages/backend/user/form/SysFormInfoList.vue')

const Repertory = () => import('@/pages/backend/user/repertory/Repertory.vue')
const RepertoryLabel = () => import('@/pages/backend/user/repertory/label/RepertoryLabel.vue')
const RepertoryWatermark = () => import('@/pages/backend/user/repertory/watermark/RepertoryWatermark.vue')
const RepertoryRefuse = () => import('@/pages/backend/user/repertory/refuse/RepertoryRefuse.vue')
// 域名设置
const DomainView = () => import('@/pages/backend/user/host/domain/DomainView.vue')
const SiteView = () => import('@/pages/backend/user/host/setup/SiteView.vue')
const OperateLog = () => import('@/pages/backend/user/operate/Log.vue')
const Hostip = () => import('@/pages/backend/user/host/hostip/Hostip.vue')
const Messagenotify = () => import('@/pages/backend/user/host/messagenotify/Messagenotify.vue')
const Adwords = () => import('@/pages/backend/user/host/adwords/Adwords.vue')

const Promotion = () => import('@/pages/backend/user/promotion/Promotion.vue')

const Virtualroot = () => import('@/pages/backend/user/virtualroot/Virtualroot.vue')

const Backuprestore = () => import('@/pages/backend/user/backuprestore/Backuprestore.vue')

export default [
  {
    path: '/backend/user',
    name: '欢迎页',
    component: Welcome
  },
  {
    path: '/backend/user/welcome',
    name: '欢迎页/welcome',
    component: Welcome
  },
  {
    path: '/backend/user/siteinfo',
    name: '网站信息',
    component: SiteInfo
  },
  {
    path: '/backend/user/siteseo',
    name: 'SEO设置',
    component: SiteSeo
  },
  {
    path: '/backend/user/codemanagement/sitecode',
    name: '站点代码',
    component: SiteCode
  },
  {
    path: '/backend/user/codemanagement/pagecode',
    name: '页面代码',
    component: PageCode
  },
  {
    path: '/backend/user/pages',
    name: '页面管理',
    component: Pages
  },
  {
    path: '/backend/user/system',
    name: '系统管理',
    component: SystemList
  },
  {
    path: '/backend/user/system/category',
    name: '系统分类',
    component: SystemCategory
  },
  {
    path: '/backend/user/system/article-list',
    name: '文章系统列表',
    component: SystemArticleList
  },
  {
    path: '/backend/user/system/article-item',
    name: '文章编辑',
    component: SystemArticleItem
  },
  {
    path: '/backend/user/system/article-refuse',
    name: '文章系统回收站',
    component: SystemArticleRefuse
  },
  {
    path: '/backend/user/system/product-list',
    name: '产品系统列表',
    component: SystemProductList
  },
  {
    path: '/backend/user/system/product-item',
    name: '产品编辑',
    component: SystemProductItem
  },
  {
    path: '/backend/user/system/product-refuse',
    name: '产品系统回收站',
    component: SystemProductRefuse
  },
  {
    path: '/backend/user/system/download-list',
    name: '下载系统列表',
    component: SystemDownloadList
  },
  {
    path: '/backend/user/system/download-item',
    name: '下载内容编辑',
    component: SystemDownloadItem
  },
  {
    path: '/backend/user/system/download-attr',
    name: '下载属性设置',
    component: SystemDownloadAttribute
  },
  {
    path: '/backend/user/system/download-refuse',
    name: '下载系统回收站',
    component: SystemDownloadRefuse
  },
  {
    path: '/backend/user/system/faq-list',
    name: 'FAQ系统列表',
    component: SystemFaqList
  },
  {
    path: '/backend/user/system/faq-item',
    name: 'FAQ编辑',
    component: SystemFaqItem
  },
  {
    path: '/backend/user/system/faq-refuse',
    name: 'FAQ系统回收站',
    component: SystemFaqRefuse
  },
  {
    path: '/backend/user/system/information-list',
    name: '信息系统列表',
    component: SystemInformationList
  },
  {
    path: '/backend/user/system/information-item',
    name: '信息系统内容编辑',
    component: SystemInformationItem
  },
  {
    path: '/backend/user/system/information-attr',
    name: '信息系统属性设置',
    component: SystemInformationAttribute
  },
  {
    path: '/backend/user/system/information-refuse',
    name: '信息系统回收站',
    component: SystemInformationRefuse
  },
  {
    path: '/backend/user/system/pdtable-list',
    name: '产品表格系统列表',
    component: SystemPdtableList
  },
  {
    path: '/backend/user/system/pdtable-item',
    name: '产品表格系统内容编辑',
    component: SystemPdtableItem
  },
  {
    path: '/backend/user/system/pdtable-attr',
    name: '产品表格系统属性设置',
    component: SystemPdtableAttribute
  },
  {
    path: '/backend/user/system/pdtable-refuse',
    name: '产品表格系统回收站',
    component: SystemPdtableRefuse
  },
  {
    path: '/backend/user/form',
    name: '页面表单',
    component: FormList
  },
  {
    path: '/backend/user/form/infolist',
    name: '页面表单提交数据列表',
    component: FormInfoList
  },
  {
    path: '/backend/user/sysform',
    name: '系统表单',
    component: SysFormList
  },
  {
    path: '/backend/user/form/sysinfolist',
    name: '系统表单提交数据列表',
    component: SysFormInfoList
  },
  {
    path: '/backend/user/repertory',
    name: '资源库',
    component: Repertory
  },
  {
    path: '/backend/user/repertory/label',
    name: '资源库标签',
    component: RepertoryLabel
  },
  {
    path: '/backend/user/repertory/watermark',
    name: '水印设置',
    component: RepertoryWatermark
  },
  {
    path: '/backend/user/repertory/refuse',
    name: '资源回收站',
    component: RepertoryRefuse
  },
  {
    path: '/backend/user/host/domain',
    name: '域名设置',
    component: DomainView
  },
  {
    path: '/backend/user/host/setup',
    name: '整站设置',
    component: SiteView
  },
  {
    path: '/backend/user/host/hostip',
    name: '黑/白名单',
    component: Hostip
  },
  {
    path: '/backend/user/host/adwords',
    name: '关键词过滤',
    component: Adwords
  },
  {
    path: '/backend/user/host/messagenotify',
    name: '消息通知',
    component: Messagenotify
  },
  {
    path: '/backend/user/operate/log',
    name: '操作日志',
    component: OperateLog
  },
  {
    path: '/backend/user/promotion',
    name: '推广管理',
    component: Promotion
  },
  {
    path: '/backend/user/virtualroot',
    name: '虚拟目录',
    component: Virtualroot
  },
  {
    path: '/backend/user/backuprestore',
    name: '备份管理',
    component: Backuprestore
  }
]



// WEBPACK FOOTER //
// ./src/router/backend/user/index.js